<template>
  <v-menu v-bind="$attrs" v-model="menu" :close-on-content-click="true" :nudge-width="200" offset-x>
    <template v-slot:activator="{ on }">
      <v-btn :color="isMobileSize ? 'white' : 'primary'" icon v-on="on">
        <v-avatar>
            <v-icon>mdi-account-circle</v-icon>
          <!-- <img :src="profile" :alt="$user.email" /> -->
        </v-avatar>
      </v-btn>
      <!-- <v-btn color="indigo" dark v-on="on">Menu as Popover</v-btn> -->
    </template>
    <v-card>
      <v-list>
        <v-list-item>

          <v-list-item-avatar>              
            <img :src="profile" :alt="$user.email" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{$user.nome}}</v-list-item-title>
            <v-list-item-subtitle>{{$user.email}}</v-list-item-subtitle>
          </v-list-item-content>
          <!-- <v-list-item-action>
            <v-btn :class="fav ? 'red--text' : ''" icon @click="fav = !fav">
              <v-icon>mdi-heart</v-icon>
            </v-btn>
          </v-list-item-action>-->
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item-group>
          <v-list-item v-for="(item, i) in listAvatarMenu" :key="i" :to="item.to">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    profile: require("@/assets/profile.png"),    
    menu: false
  }),
  computed: {
      ...mapState("auth", ["logged", "userName"]),
      listAvatarMenu() {
          return [
          { text: "Meus Dados", icon: "mdi-account", to: "/meu-perfil" },          
          { text: "Sair", icon: "mdi-exit-to-app", to: '/logout' }
        ]
      }
  }
};
</script>